import swiperTimelineLiveries from "./swiperTimelineLiveries";

const swiperCarsLiveries = {
    swiperInstance: null,
    swiperInstancePagination: null,

    init: () => {
        import('swiper/bundle').then(({Swiper}) => {
            let domEls = document.querySelectorAll('.js-swiper-cars-liveries');
            let domElsPagination = document.querySelectorAll('.js-swiper-cars-liveries-pagination');

            let mainArray  = [];
            let navArray   = [];

            if (domEls && domElsPagination) {
                const paginationParams = getSwiperPaginationParams();
                const params = getSwiperParams();

                domEls.forEach(function(el, i) {
                    swiperCarsLiveries.swiperInstance = mainArray.push(
                        new Swiper(el, params)
                    );
                })

                domElsPagination.forEach(function(el, i) {
                    swiperCarsLiveries.swiperInstancePagination = navArray.push(
                        new Swiper(el, paginationParams)
                    );
                })

                let numberOfSlides = mainArray.length || navArray.length || 0;

                if (mainArray.length !== navArray.length) {
                    console.warn('multipleSwiperSlides: Number of main slides and nav slides is different. Expect incorrect behaviour.');
                }

                function slideOtherGalleryTo(sGalleryName, nSlideIndex) {
                    sGalleryName.slideTo(nSlideIndex);
                }

                for (let i = 0; i < numberOfSlides ; i++ ) {
                    mainArray[i].thumbs = navArray[i];

                    // actions on transitionStart of thumbs
                    navArray[i].on('transitionStart', function () {
                        let activeIndex = this.realIndex;
                        slideOtherGalleryTo(mainArray[i], activeIndex);
                    });
                }
            }
        })
    }
};

const getSwiperPaginationParams = () => {
    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 24,
        // slidesPerView: 2,
        slidesPerView: 'auto',
        speed: 500,
        a11y: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        breakpoints: {
            769: {
                spaceBetween: 0,
                // slidesPerView: 'auto',
                direction: "vertical",
                allowTouchMove: false,
            }
        }
    };
};

const getSwiperParams = () => {

    return {
        watchOverflow: true,
        centeredSlides: true,
        slidesPerView: 1,
        speed: 500,
        slideToClickedSlide: false,
        resizeObserver: true,
        a11y: true,
        effect: "fade",
        allowTouchMove: false,
        autoHeight: true
    }
}

export default swiperCarsLiveries;